import {
  Box,
  Modal,
  styled,
  Button,
  BoxProps,
  ModalProps,
  Typography,
  ButtonProps,
  TypographyProps,
} from "@mui/material";

export const ModalContainer = styled(Modal)<ModalProps>(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const Card = styled(Box)<BoxProps>(() => ({
  position: "absolute",
  top: "45%",
  left: "55%",
  transform: "translate(-50%, -50%)",
  width: "300px",
  bgcolor: "#FFF",
  padding: "40px",
  background: "#FFF",
}));

export const Title = styled(Typography)<TypographyProps>(() => ({
  textAlign: "center",
  fontWeight: "bold",
}));

export const Description = styled(Typography)<TypographyProps>(() => ({
  textAlign: "center",
  marginTop: "30px",
  marginBottom: "20px",
  fontSize: "16px",
}));

export const CustomButton = styled(Button)<ButtonProps>(() => ({
  width: "100%",
  background: "#F77822",
  color: "#FFF",
  marginTop: "50px",
}));
